import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { InformModal } from '../../../common/SharedComponents';
import { getWatchlistActions, executeWatchlistAction } from '../WatchlistFunctions';

export const WatchlistActionsButton = ({ data, summaryTypeId }) => {
    const { dispatch } = store;

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, wlLoan) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getWatchlistActions(wlLoan);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        executeWatchlistAction(e.itemData, dispatch, summaryTypeId);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${data.loanId}_${data.watchlistId}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
